import { apiClient } from './api';
import type {
  BodyMeasurementsByDate,
  BodyMeasurementChartPoint,
  BatchMeasurementInput,
  LatestMeasurements,
} from './types';

export class BodyMeasurementService {
  private static readonly ENDPOINT = '/api/body-measurements';

  static async batchSave(input: BatchMeasurementInput): Promise<void> {
    await apiClient.post(`${this.ENDPOINT}/batch`, input);
  }

  static async getMeasurementsByDate(limit: number = 20): Promise<BodyMeasurementsByDate[]> {
    const response = await apiClient.get<BodyMeasurementsByDate[]>(`${this.ENDPOINT}/by-date?limit=${limit}`);
    return response.data;
  }

  static async getChartData(metric: string): Promise<BodyMeasurementChartPoint[]> {
    const response = await apiClient.get<BodyMeasurementChartPoint[]>(`${this.ENDPOINT}/chart-data?metric=${metric}`);
    return response.data;
  }

  static async getLatest(): Promise<LatestMeasurements> {
    const response = await apiClient.get<LatestMeasurements>(`${this.ENDPOINT}/latest`);
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await apiClient.delete(`${this.ENDPOINT}/${id}`);
  }

  static async deleteByDate(date: string): Promise<void> {
    await apiClient.delete(`${this.ENDPOINT}/by-date/${date}`);
  }
}

export default BodyMeasurementService;
